module.exports = __webpack_public_path__ + "img/http-expand-icon.057e919c.svg";